import React from 'react';
import { withRouter } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from 'components/CustomButtons/Button.jsx';
import PageTitle from 'components/inc/PageTitle.jsx';
import TextField from '@material-ui/core/TextField';
import LoadingComponent from 'components/inc/LoadingComponent';
import style from 'assets/jss/material-kit-pro-react/views/componentsSections/contentAreas.jsx';
import { connect } from 'react-redux';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {
  getProjectDetails,
  saveProject,
  updateProject,
} from '../../../actions/project';
import _ from 'lodash-es';
import queryString from 'query-string';
import { Editor } from 'react-draft-wysiwyg';
import { convertToRaw, EditorState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import { stateFromHTML } from 'draft-js-import-html';
import './ProjectForm.scss';
import { Link, Redirect } from 'react-router-dom';

class ProjectForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstStep: 'first step here',
      projectTitle: props.project ? props.project.title : '',
      projectDescription: props.project ? props.project.description : '',
      projectTitleError: false,
      projectDescriptionError: false,
      projectUpdated: false,
      isLoading: false,
      newProjectId: null,
      editorStateProjectDesc: props.project
        ? EditorState.createWithContent(
            stateFromHTML(props.project.description)
          )
        : EditorState.createEmpty(),
    };
    this.onSubmit = this.onSubmit.bind(this); // Rename to onSubmit
  }

  onEditorProjectDescStateChange = (editorState) => {
    this.setState({
      editorStateProjectDesc: editorState,
    });
    this.setState({
      projectDescription: draftToHtml(
        convertToRaw(editorState.getCurrentContent())
      ),
    });
  };

  onEditorProjectDescStateBlur = (descText) => {
    if (!descText) {
      this.setState({ projectDescriptionError: true });
    } else {
      this.setState({ projectDescriptionError: false });
    }
  };

  handleProjectTitle = (event) => {
    this.setState({ projectTitle: event.target.value });
  };

  handleProjectTitleValidation = (event) => {
    if (!event.target.value) {
      this.setState({ projectTitleError: true });
    } else {
      this.setState({ projectTitleError: false });
    }
  };

  async onSubmit(e) {
    e.preventDefault();
    this.setState({
      isLoading: true,
      projectTitleError: !this.state.projectTitle,
      projectDescriptionError: !this.state.projectDescription,
    });
    const isFormValid =
      this.state.projectTitle && this.state.projectDescription;
    if (isFormValid) {
      const data = {
        title: this.state.projectTitle,
        description: this.state.projectDescription,
      };
      if (this.props.project) {
        await this.props.updateProject(data, this.props.project._id);
        this.setState({
          projectUpdated: true,
        });
      } else {
        const response = await this.props.saveProject(data);
        if (response.success) {
          this.setState({
            newProjectId: response.data._id,
          });
        }
      }
    }
    this.setState({ isLoading: false });
    return false;
  }

  render() {
    const { editorStateProjectDesc } = this.state;
    if (this.state.projectUpdated) {
      return <Redirect to={`/projects/${this.props.project._id}`} />;
    }
    if (this.state.newProjectId) {
      return (
        <Redirect to={`/projects/${this.state.newProjectId}/create-sprint`} />
      );
    }
    return (
      <div>
        <form onSubmit={this.onSubmit}>
          <div className='form-element'>
            <div className='title form-label'>
              <h3 className='form-label-text'>Project Title:</h3>
            </div>
            <TextField
              id='regular'
              inputProps={{
                maxLength: 150,
                placeholder: '',
              }}
              className='form-textfield'
              fullWidth={true}
              error={this.state.projectTitleError ? true : false}
              value={this.state.projectTitle}
              onChange={(e) => {
                this.handleProjectTitle(e);
              }}
              onBlur={(e) => {
                this.handleProjectTitleValidation(e);
              }}
            />
          </div>
          <div className='form-element'>
            <div className='title form-label'>
              <h3 className='form-label-text'>Project Description:</h3>
            </div>
            <Editor
              editorState={editorStateProjectDesc}
              toolbarClassName='toolbarClassName'
              wrapperClassName={
                this.state.projectDescriptionError
                  ? 'editorWrapper editorRequiredError'
                  : 'editorWrapper'
              }
              editorClassName='editorClassName'
              onEditorStateChange={this.onEditorProjectDescStateChange}
              onBlur={() =>
                this.onEditorProjectDescStateBlur(
                  editorStateProjectDesc.getCurrentContent().hasText()
                )
              }
            />
          </div>
          <div className='form-element bottom-actions'>
            {!this.props.project && (
              <>
                <Button
                  type='submit'
                  color='success'
                  className='bottom-action-button'
                  round
                >
                  Save and Continue
                </Button>
              </>
            )}

            {this.props.project && (
              <>
                <Button
                  type='submit'
                  color='success'
                  className='bottom-action-button'
                  round
                >
                  Update
                </Button>
                <Link to={`/projects/${this.props.project._id}/create-sprint`}>
                  <Button
                    type='button'
                    className='bottom-action-button'
                    color='default'
                    round
                  >
                    Add a Sprint
                  </Button>
                </Link>
              </>
            )}
          </div>
        </form>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
  getProjectDetails: (projectId) => dispatch(getProjectDetails(projectId)),
  saveProject: (data) => dispatch(saveProject(data)),
  updateProject: (data, projectId) => dispatch(updateProject(data, projectId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { withRef: true }
)(ProjectForm);
